import CreateResourceInteractor from "../../core/interactor/app/crud/CreateResourceInteractor";
import Constants from "../common/Constants";
import { IAttachment } from "../../caseLawDocuments/model/Attachment";
import AttachmentMapper from "../../caseLawDocuments/service/AttachmentMapper";
import AttachmentParamMapper from "../../caseLawDocuments/service/AttachmentParamMapper";

export default class CreateLegalViewAttachmentInteractor {
  private createResource: CreateResourceInteractor<IAttachment>;

  constructor({ createResource }: any) {
    this.createResource = createResource;
  }

  async execute(model: IAttachment, legalViewId?: number) {
    return this.createResource.execute(
      `legal-views/${legalViewId}/${Constants.attachmentPath}`,
      AttachmentMapper,
      AttachmentParamMapper,
      model
    );
  }
}
